import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, TButton } from '@/shared/ui/lib/Button';
import { SvgIcon } from '@/shared/ui/SvgIcon';
import { CompanyDepartmentDto } from '@/shared/api/companies';

import { AddEmployeeToCompanyDialog } from './AddEmployeeToCompanyDialog';

type AddEmployeeToCompanyButtonProps = TButton & {
  companyId: string;
  departments: CompanyDepartmentDto[];
};

export const AddEmployeeToCompanyButton = ({
  companyId,
  departments,
  ...props
}: AddEmployeeToCompanyButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        startIcon={<SvgIcon name="add" />}
        size="large"
        {...props}
      >
        {t('company:buttons.addEmployee')}
      </Button>
      <AddEmployeeToCompanyDialog
        open={open}
        onClose={handleClose}
        companyId={companyId}
        departments={departments}
      />
    </>
  );
};
